module.exports = __webpack_public_path__ + "static/media/Queenie Goldstein 3.f43f23e8.jpg";